/*global REACT_APP_API_BASE_URL_NEW:true*/
import request from "@/utils/request";

export async function validateFeature(devKey) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/feature-management/features/validate`, {
    method: "POST",
    params: {
      devKey,
    },
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }

  return result?.data;
}
